/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
import { call, put, takeEvery } from 'redux-saga/effects';
import { actions } from '../../utils/constants';

import {
    fetchTemplateTests,
    deleteTemplateTest,
    fetchTestTypes,
} from '../../utils/common-functions';

function* asyncFetchTemplateTests({
    payload: { page, pageSize, orderBy, orderMode, typeTest, label, status },
}) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });
        const params = {};

        Object.assign(params, { order: !!orderBy ? orderBy : 'created_at' });
        Object.assign(params, { order_mode: !!orderMode ? orderMode : 'desc' });

        if (page !== undefined) {
            Object.assign(params, { page });
        }
        if (pageSize) {
            Object.assign(params, { page_size: pageSize });
        }
        if (typeTest) {
            Object.assign(params, { test_type: typeTest });
        }
        if (label) {
            Object.assign(params, { search: label });
        }
        if (status) {
            Object.assign(params, { status: status });
        }

        const response = yield call(fetchTemplateTests, params, true);

        const { template_tests, total } = response.data;
        yield put({
            type: actions.CHANGE_TEMPLATE_TESTS,
            payload: { template_tests, total },
        });
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
    } catch (err) {
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: 'Não foi possível listar os testes',
            },
        });
    }
}

function* asyncRemoveTemplateTest({ payload: { testId } }) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        yield call(deleteTemplateTest, { testId });

        yield put({
            type: actions.CHANGE_SHOULD_BE_REFRESH_TEMPLATE_TESTS,
            payload: true,
        });

        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
    } catch (err) {
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: err.response.data.error_description,
            },
        });
    }

    yield put({
        type: actions.CHANGE_MODAL_REMOVE_TEMPLATE_TEST,
        payload: false,
    });
}

function* fecthTypeTestsToFilter() {
    try {
        const response = yield call(fetchTestTypes);

        const testTypes = response.data.test_types;
        yield put({
            type: actions.CHANGE_TEST_TYPES_TO_FILTER,
            payload: testTypes,
        });
    } catch (e) {
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message:
                    'Não foi possível realizar a busca por tipos de testes. Tente novamente',
            },
        });
    }
}

export default function* tests() {
    yield takeEvery(
        actions.ASYNC_FETCH_TEMPLATE_TESTS,
        asyncFetchTemplateTests,
    );
    yield takeEvery(
        actions.ASYNC_REMOVE_TEMPLATE_TEST,
        asyncRemoveTemplateTest,
    );
    yield takeEvery(
        actions.ASYNC_FETCH_TEST_TYPES_TO_FILTER,
        fecthTypeTestsToFilter,
    );
}



// WEBPACK FOOTER //
// ./src/components/tests/tests.saga.js